export default __webpack_public_path__ + "static/media/camera.6ffd0834.svg";